import { render, staticRenderFns } from "./membershipAdd.vue?vue&type=template&id=537527e7"
import script from "./membershipAdd.vue?vue&type=script&lang=js"
export * from "./membershipAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports